module.exports = __webpack_public_path__ + "static/fonts/notokr-medium.6a273c1.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/affiliatecard/font/notokr-medium.woff2
// module id = F4h9
// module chunks = 0